import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/other/index'
import contact from '@/pages/other/contact'
import info from '@/pages/other/info'
import contactUs from '@/pages/other/contactus'
import contactWechat from '@/pages/other/contact-wechat'
import contactClean from '@/pages/other/contact-clean'
import contactMoveBusiness from '@/pages/other/contact-move-business'
import addressList from '@/pages/other/address'
import cleanComparison from '@/pages/other/clean-comparison'
import reg from '@/pages/user/reg'
import regSuccess from '@/pages/user/reg-success'
import loginSuccess from '@/pages/user/login-success'
import orderSuccess from '@/pages/order/order-success'
import orderTempSuccess from '@/pages/order/order-temp-success'
import orderErrorCC from '@/pages/order/order-error-cc'
import orderErrorPoli from '@/pages/order/order-error-poli'
import orderCancel from '@/pages/order/order-cancel'
import login from '@/pages/user/login'
import profile from '@/pages/user/profile'
import profileLogin from '@/pages/user/profile-login'
import review from '@/pages/review/comment'
import gallery from '@/pages/review/gallery'

import resetPassword from '@/pages/user/reset'
import newPassword from '@/pages/user/new-password'
import newUserSurvey from '@/pages/user/new-user-survey'
import forgetPassword from '@/pages/user/forget-password'
import orderList from '@/pages/order/order-list'
import orderLogin from '@/pages/order/order-login'
import orderDetail from '@/pages/order/order-detail'
import orderPrepay from '@/pages/order/order-prepay'
import couponList from '@/pages/coupon/list'
import couponApply from '@/pages/coupon/apply'
import couponGet from '@/pages/coupon/get'
import couponGetSuccess from '@/pages/coupon/get-success'
import orderCC from '@/pages/order/order-cc'
import orderUPOP from '@/pages/order/order-upop'
import cleanStep0 from '@/pages/clean/step0'
import cleanStep1 from '@/pages/clean/step1'
import cleanStep2 from '@/pages/clean/step2'
import cleanStep3 from '@/pages/clean/step3'
import cleanStep4 from '@/pages/clean/step4'
import cleanStep5 from '@/pages/clean/step5'
import cleanStep6 from '@/pages/clean/step6'
import cleanStep7 from '@/pages/clean/step7'
import organizationStep1 from '@/pages/organization/step1'
import organizationStep2 from '@/pages/organization/step2'
import organizationStep3 from '@/pages/organization/step3'
import organizationStep4 from '@/pages/organization/step4'
import organizationStep5 from '@/pages/organization/step5'
import organizationPricing from '@/pages/organization/pricing'
import organizationOrder from '@/pages/organization/order-detail'
import organizationAbstract from '@/pages/organization/abstract'

import cleanTerms from '@/pages/clean/terms'
import cleanPricing from '@/pages/clean/pricing'
import cleanParking from '@/pages/clean/parking'
import cleanSwitch from '@/pages/clean/clean-switch'
import cleanOrder from '@/pages/clean/order-detail'
import cleanOrderPrice from '@/pages/clean/order-detail-price'
import cleanOrderInvoice from '@/pages/clean/order-detail-invoice'
import cleanGuide from '@/pages/cleanEx/clean-guide'
import cleanExStep0 from '@/pages/cleanEx/step0'
import cleanExStep1 from '@/pages/cleanEx/step1'
import cleanExStep2 from '@/pages/cleanEx/step2'
import cleanExStep3 from '@/pages/cleanEx/step3'
import cleanExStep4 from '@/pages/cleanEx/step4'
import cleanExStep5 from '@/pages/cleanEx/step5'
import cleanExOrderInvoice from '@/pages/cleanEx/order-detail-invoice'
import cleanExOrder from '@/pages/cleanEx/order-detail'
import cleanExOrderPrice from '@/pages/cleanEx/order-detail-price'
import miscIndex from '@/pages/misc/index'
import miscDetail from '@/pages/misc/detail'
import miscStep1 from '@/pages/misc/step1'
import miscStep2 from '@/pages/misc/step2'
import miscStep3 from '@/pages/misc/step3'
import miscStep4 from '@/pages/misc/step4'
import miscOrder from '@/pages/misc/order-detail'
import pestStep1 from '@/pages/pest/step1'
import pestStep2 from '@/pages/pest/step2'
import pestStep2Moveout from '@/pages/pest/step2-moveout'
import pestStep3 from '@/pages/pest/step3'
import pestStep3House from '@/pages/pest/step3-house'
import pestStep4 from '@/pages/pest/step4'
import pestStep5 from '@/pages/pest/step5'
import pestStep6 from '@/pages/pest/step6'
import pestAbstract from '@/pages/pest/abstract'
import pestPricing from '@/pages/pest/pricing'
import pestOrder from '@/pages/pest/order-detail'

import householdStep1 from '@/pages/household/step1'
import householdStep2 from '@/pages/household/step2'
import householdStep3 from '@/pages/household/step3'
import householdStep4 from '@/pages/household/step4'
import moveStep1 from '@/pages/move/step1'
import moveStep2 from '@/pages/move/step2'
import moveStep3 from '@/pages/move/step3'
import moveStep3In from '@/pages/move/step3-address-in'
import moveStep3Out from '@/pages/move/step3-address-out'
import moveStep3Wp from '@/pages/move/step3-address-wp'
import moveStep4 from '@/pages/move/step4'
import moveStep5 from '@/pages/move/step5'
import moveStep6 from '@/pages/move/step6'
import moveInsurance from '@/pages/move/insurance'
import moveInsuranceInfo from '@/pages/move/insurance-info'
import moveVehicle from '@/pages/move/vehicle'
import moveBusinessIntro from '@/pages/move/business-intro'
import moveParking from '@/pages/move/parking'
import moveOrder from '@/pages/move/order-detail'
import moveOrderPrice from '@/pages/move/order-detail-price'
import moveOrderInvoice from '@/pages/move/order-detail-invoice'
import baggageCalc from '@/pages/baggage/calc'
import baggageStep1 from '@/pages/baggage/step1'
import baggageStep2 from '@/pages/baggage/step2.vue'
import baggageStep2From from '@/pages/baggage/step2-from.vue'
import baggageStep2To from '@/pages/baggage/step2-to.vue'
import baggageStep2ToMore from '@/pages/baggage/step2-to-more.vue'
import baggageStep3 from '@/pages/baggage/step3'
import baggageStep4 from '@/pages/baggage/step4'
import baggagePrice from '@/pages/baggage/price'
import baggageInfo from '@/pages/baggage/info'
import baggageWarn from '@/pages/baggage/warn'
import baggageBusinessIntro from '@/pages/baggage/business-intro'
import baggageParking from '@/pages/baggage/parking'
import baggageOrder from '@/pages/baggage/order-detail'
import baggageOrderPrice from '@/pages/baggage/order-detail-price'
import baggageOrderInvoice from '@/pages/baggage/order-detail-invoice'
import storageIntro from '@/pages/storage/intro'
import storageCalc from '@/pages/storage/calc'
import storageAbstract from '@/pages/storage/abstract'
import storageStep1 from '@/pages/storage/step1'
import storageStep2 from '@/pages/storage/step2'
import storageStep3 from '@/pages/storage/step3'
import storageStep4 from '@/pages/storage/step4'
import storageStep5 from '@/pages/storage/step5'
import storageOrder from '@/pages/storage/order-detail'
import storageOrderSub from '@/pages/storage/order-detail-sub'
import storageOrderUpdate from '@/pages/storage/order-update'
import warehouseStep1 from '@/pages/warehouse/step1'
import warehouseStep2 from '@/pages/warehouse/step2'
import warehouseStep3 from '@/pages/warehouse/step3'
import warehouseStep4 from '@/pages/warehouse/step4'
import warehouseStep5 from '@/pages/warehouse/step5'
import warehouseStep6 from '@/pages/warehouse/step6'
import warehouseOrder from '@/pages/warehouse/order-detail'
import warehouseOrderSub from '@/pages/warehouse/order-detail-sub'
import generalStep1 from '@/pages/general/step1'
import generalStep2 from '@/pages/general/step2'
import generalStep3 from '@/pages/general/step3'
import generalStep4 from '@/pages/general/step4'
import generalStep5 from '@/pages/general/step5'
import generalStep6 from '@/pages/general/step6'
import suburbFilter from '@/pages/global/suburb-filter'
import moveTerms from '@/pages/other/moveTerms'
import refund from '@/pages/other/refund'
import terms from '@/pages/other/terms'
import empty from '@/pages/other/empty'
import serviceWorker from '@/pages/service/worker'
import serviceWorkerForm from '@/pages/service/form/worker'
import serviceConvey from '@/pages/service/convey'
import serviceConveyForm from '@/pages/service/form/convey'
import serviceStorage from '@/pages/service/storage'
import serviceStorageForm from '@/pages/service/form/storage'
import serviceCleanForm from '@/pages/cleanEx/clean-index'
import serviceCleanPrice from '@/pages/cleanEx/clean-price'
import serviceCar from '@/pages/service/car'
import serviceCarForm from '@/pages/service/form/car'
import serviceJoinus from '@/pages/service/joinus'
import serviceDisinfect from '@/pages/service/disinfect'
import serviceJoinusForm from '@/pages/service/form/joinus'
import serviceRecruitForm from '@/pages/service/form/recruit'
import serviceDisinfectForm from '@/pages/service/form/disinfect'
import callBackForm from '@/pages/service/form/callback'
import payCash from '@/pages/order/pay-cash'
import payBank from '@/pages/order/pay-bank'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 150)
      })
    } else {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            x: 0,
            y: 0
          })
        }, 150)
      })
    }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/contact-wechat',
      name: 'contactWechat',
      component: contactWechat
    },
    {
      path: '/contact-clean',
      name: 'contactClean',
      component: contactClean
    },
    {
      path: '/contact-move-business',
      name: 'contactMoveBusiness',
      component: contactMoveBusiness
    },
    {
      path: '/reg',
      name: 'reg',
      component: reg
    },
    {
      path: '/reg-success',
      name: 'regSuccess',
      component: regSuccess
    },
    {
      path: '/order-success',
      name: 'orderSuccess',
      component: orderSuccess
    },
    {
      path: '/order-cancel',
      name: 'orderCancel',
      component: orderCancel
    },
    {
      path: '/order-form-success',
      name: 'orderTempSuccess',
      component: orderTempSuccess
    },
    {
      path: '/order-error-cc',
      name: 'orderErrorCC',
      component: orderErrorCC
    },
    {
      path: '/order-error-poli',
      name: 'orderErrorPoli',
      component: orderErrorPoli
    },
    {
      path: '/login-success',
      name: 'loginSuccess',
      component: loginSuccess
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile
    },
    {
      path: '/review',
      name: 'review',
      component: review
    },
    {
      path: '/review/gallery',
      name: 'gallery',
      component: gallery
    },
    {
      path: '/profile-login',
      name: 'profileLogin',
      component: profileLogin
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      component: resetPassword
    },
    {
      path: '/new-password',
      name: 'newPassword',
      component: newPassword
    },
    {
      path: '/new-user-survey',
      name: 'newUserSurvey',
      component: newUserSurvey
    },
    {
      path: '/forget-password',
      name: 'forgetPassword',
      component: forgetPassword
    },
    {
      path: '/order',
      name: 'order',
      component: orderList
    },
    {
      path: '/order-detail',
      name: 'orderDetail',
      component: orderDetail
    },
    {
      path: '/order-login',
      name: 'orderLogin',
      component: orderLogin
    },
    {
      path: '/order-prepay',
      name: 'orderPrepay',
      component: orderPrepay
    },
    {
      path: '/coupon-list',
      name: 'couponList',
      component: couponList
    },
    {
      path: '/coupon-apply',
      name: 'couponApply',
      component: couponApply
    },
    {
      path: '/coupon-get',
      name: 'couponGet',
      component: couponGet
    },
    {
      path: '/coupon-get-success',
      name: 'couponGetSuccess',
      component: couponGetSuccess
    },
    {
      path: '/payment-cc',
      name: 'orderCC',
      component: orderCC
    },
    {
      path: '/payment-upop',
      name: 'orderUPOP',
      component: orderUPOP
    },
    {
      path: '/clean-start',
      name: 'cleanStep0',
      component: cleanStep0
    },
    {
      path: '/clean-step1',
      name: 'cleanStep1',
      component: cleanStep1
    },
    {
      path: '/cleanex-start',
      name: 'cleanExStep0',
      component: cleanExStep0
    },
    {
      path: '/cleanex-step1',
      name: 'cleanExStep1',
      component: cleanExStep1
    },
    {
      path: '/cleanex-step2',
      name: 'cleanExStep2',
      component: cleanExStep2
    },
    {
      path: '/cleanex-step3',
      name: 'cleanExStep3',
      component: cleanExStep3
    },
    {
      path: '/cleanex-step4',
      name: 'cleanExStep4',
      component: cleanExStep4
    },
    {
      path: '/cleanex-step5',
      name: 'cleanExStep5',
      component: cleanExStep5
    },
    {
      path: '/empty',
      name: 'empty',
      component: empty
    },
    {
      path: '/service/car',
      name: 'serviceCar',
      component: serviceCar
    },
    {
      path: '/service/joinus',
      name: 'serviceJoinus',
      component: serviceJoinus
    },
    {
      path: '/service/disinfect',
      name: 'serviceDisinfect',
      component: serviceDisinfect
    },
    {
      path: '/service/form/car',
      name: 'serviceCarForm',
      component: serviceCarForm
    },
    {
      path: '/service/form/joinus',
      name: 'serviceJoinusForm',
      component: serviceJoinusForm
    },
    {
      path: '/service/form/recruit',
      name: 'serviceRecruitForm',
      component: serviceRecruitForm
    },
    {
      path: '/service/form/disinfect',
      name: 'serviceDisinfectForm',
      component: serviceDisinfectForm
    },
    {
      path: '/service/form/callback',
      name: 'callBackForm',
      component: callBackForm
    },
    {
      path: '/service/form/clean',
      name: 'serviceCleanForm',
      component: serviceCleanForm
    },

    {
      path: '/service/clean-price',
      name: 'serviceCleanPrice',
      component: serviceCleanPrice
    },
    {
      path: '/service/storage',
      name: 'serviceStorage',
      component: serviceStorage
    },
    {
      path: '/service/form/storage',
      name: 'serviceStorageForm',
      component: serviceStorageForm
    },
    {
      path: '/service/worker',
      name: 'serviceWorker',
      component: serviceWorker
    },
    {
      path: '/service/form/worker',
      name: 'serviceWorkerForm',
      component: serviceWorkerForm
    },
    {
      path: '/service/convey',
      name: 'serviceConvey',
      component: serviceConvey
    },
    {
      path: '/service/form/convey',
      name: 'serviceConveyForm',
      component: serviceConveyForm
    },
    {
      path: '/clean-step2',
      name: 'cleanStep2',
      component: cleanStep2
    },
    {
      path: '/clean-step3',
      name: 'cleanStep3',
      component: cleanStep3
    },
    {
      path: '/clean-step4',
      name: 'cleanStep4',
      component: cleanStep4
    },
    {
      path: '/clean-step5',
      name: 'cleanStep5',
      component: cleanStep5
    },
    {
      path: '/clean-step6',
      name: 'cleanStep6',
      component: cleanStep6
    },
    {
      path: '/clean-step7',
      name: 'cleanStep7',
      component: cleanStep7
    },
    {
      path: '/clean-terms',
      name: 'cleanTerms',
      component: cleanTerms
    },
    {
      path: '/clean-pricing',
      name: 'cleanPricing',
      component: cleanPricing
    },
    {
      path: '/clean/order-detail',
      name: 'cleanOrder',
      component: cleanOrder
    },
    {
      path: '/cleanex/guide',
      name: 'cleanGuide',
      component: cleanGuide
    },
    {
      path: '/clean/order-detail/price',
      name: 'cleanOrderPrice',
      component: cleanOrderPrice
    },
    {
      path: '/clean/order-detail/invoice',
      name: 'cleanOrderInvoice',
      component: cleanOrderInvoice
    },
    {
      path: '/misc/index',
      name: 'miscIndex',
      component: miscIndex
    },
    {
      path: '/misc/detail',
      name: 'miscDetail',
      component: miscDetail
    },
    {
      path: '/misc-step1',
      name: 'miscStep1',
      component: miscStep1
    },
    {
      path: '/misc-step2',
      name: 'miscStep2',
      component: miscStep2
    },
    {
      path: '/misc-step3',
      name: 'miscStep3',
      component: miscStep3
    },
    {
      path: '/misc-step4',
      name: 'miscStep4',
      component: miscStep4
    },
    {
      path: '/misc/order-detail',
      name: 'miscOrder',
      component: miscOrder
    },
    {
      path: '/pest-step1',
      name: 'pestStep1',
      component: pestStep1
    },
    {
      path: '/pest-step2',
      name: 'pestStep2',
      component: pestStep2
    },
    {
      path: '/pest-step2-moveout',
      name: 'pestStep2Moveout',
      component: pestStep2Moveout
    },
    {
      path: '/pest-step3',
      name: 'pestStep3',
      component: pestStep3
    },
    {
      path: '/pest-step3-house',
      name: 'pestStep3House',
      component: pestStep3House
    },
    {
      path: '/pest-step4',
      name: 'pestStep4',
      component: pestStep4
    },
    {
      path: '/pest-step5',
      name: 'pestStep5',
      component: pestStep5
    },
    {
      path: '/pest-step6',
      name: 'pestStep6',
      component: pestStep6
    },
    {
      path: '/pest-abstract',
      name: 'pestAbstract',
      component: pestAbstract
    },
    {
      path: '/pest-pricing',
      name: 'pestPricing',
      component: pestPricing
    },
    {
      path: '/pest/order-detail',
      name: 'pestOrder',
      component: pestOrder
    },
    {
      path: '/cleanex/order-detail',
      name: 'cleanExOrder',
      component: cleanExOrder
    }, {
      path: '/cleanex/order-detail/price',
      name: 'cleanExOrderPrice',
      component: cleanExOrderPrice
    }, {
      path: '/cleanex/order-detail/invoice',
      name: 'cleanExOrderInvoice',
      component: cleanExOrderInvoice
    },
    {
      path: '/household-step1',
      name: 'householdStep1',
      component: householdStep1
    },
    {
      path: '/household-step2',
      name: 'householdStep2',
      component: householdStep2
    },
    {
      path: '/household-step3',
      name: 'householdStep3',
      component: householdStep3
    },
    {
      path: '/household-step4',
      name: 'householdStep4',
      component: householdStep4
    },
    {
      path: '/move-step1',
      name: 'moveStep1',
      component: moveStep1
    },
    {
      path: '/move-step2',
      name: 'moveStep2',
      component: moveStep2
    },
    {
      path: '/move-step3',
      name: 'moveStep3',
      component: moveStep3
    },
    {
      path: '/move-step3/in',
      name: 'moveStep3In',
      component: moveStep3In
    },
    {
      path: '/move-step3/out',
      name: 'moveStep3Out',
      component: moveStep3Out
    },
    {
      path: '/move-step3/wp',
      name: 'moveStep3Wp',
      component: moveStep3Wp
    },
    {
      path: '/move-step4',
      name: 'moveStep4',
      component: moveStep4
    },
    {
      path: '/move-step5',
      name: 'moveStep5',
      component: moveStep5
    },
    {
      path: '/move-step6',
      name: 'moveStep6',
      component: moveStep6
    },
    {
      path: '/move-insurance',
      name: 'moveInsurance',
      component: moveInsurance
    },
    {
      path: '/move-insurance-info',
      name: 'moveInsuranceInfo',
      component: moveInsuranceInfo
    },
    {
      path: '/move-vehicle',
      name: 'moveVehicle',
      component: moveVehicle
    },
    {
      path: '/move-business-intro',
      name: 'moveBusinessIntro',
      component: moveBusinessIntro
    },
    {
      path: '/move-parking',
      name: 'moveParking',
      component: moveParking
    },
    {
      path: '/move/order-detail',
      name: 'moveOrder',
      component: moveOrder
    },
    {
      path: '/move/order-detail/price',
      name: 'moveOrderPrice',
      component: moveOrderPrice
    },
    {
      path: '/move/order-detail/invoice',
      name: 'moveOrderInvoice',
      component: moveOrderInvoice
    },
    {
      path: '/baggage-calc',
      name: 'baggageCalc',
      component: baggageCalc
    },
    {
      path: '/baggage-step1',
      name: 'baggageStep1',
      component: baggageStep1
    },
    {
      path: '/baggage-step2',
      name: 'baggageStep2',
      component: baggageStep2
    },
    {
      path: '/baggage-step2/from',
      name: 'baggageStep2From',
      component: baggageStep2From
    },
    {
      path: '/baggage-step2/to',
      name: 'baggageStep2To',
      component: baggageStep2To
    },
    {
      path: '/baggage-step2/to-more',
      name: 'baggageStep2ToMore',
      component: baggageStep2ToMore
    },
    {
      path: '/baggage-step2-to',
      name: 'baggageStep2To',
      component: baggageStep2To
    },
    {
      path: '/baggage-step3',
      name: 'baggageStep3',
      component: baggageStep3
    },
    {
      path: '/baggage-step4',
      name: 'baggageStep4',
      component: baggageStep4
    },
    {
      path: '/baggage-price',
      name: 'baggagePrice',
      component: baggagePrice
    },
    {
      path: '/baggage-info',
      name: 'baggageInfo',
      component: baggageInfo
    },
    {
      path: '/baggage-warn',
      name: 'baggageWarn',
      component: baggageWarn
    },
    {
      path: '/baggage-business-intro',
      name: 'baggageBusinessIntro',
      component: baggageBusinessIntro
    },
    {
      path: '/baggage-parking',
      name: 'baggageParking',
      component: baggageParking
    },
    {
      path: '/baggage/order-detail',
      name: 'baggageOrder',
      component: baggageOrder
    },
    {
      path: '/baggage/order-detail/price',
      name: 'baggageOrderPrice',
      component: baggageOrderPrice
    },
    {
      path: '/baggage/order-detail/invoice',
      name: 'baggageOrderInvoice',
      component: baggageOrderInvoice
    },
    {
      path: '/storage-intro',
      name: 'storageIntro',
      component: storageIntro
    },
    {
      path: '/storage-calc',
      name: 'storageCalc',
      component: storageCalc
    },
    {
      path: '/storage-abstract',
      name: 'storageAbstract',
      component: storageAbstract
    },
    {
      path: '/warehouse-step1',
      name: 'warehouseStep1',
      component: warehouseStep1
    },
    {
      path: '/warehouse-step2',
      name: 'warehouseStep2',
      component: warehouseStep2
    },
    {
      path: '/warehouse-step3',
      name: 'warehouseStep3',
      component: warehouseStep3
    },
    {
      path: '/warehouse-step4',
      name: 'warehouseStep4',
      component: warehouseStep4
    },
    {
      path: '/warehouse-step5',
      name: 'warehouseStep5',
      component: warehouseStep5
    },
    {
      path: '/warehouse-step6',
      name: 'warehouseStep6',
      component: warehouseStep6
    },
    {
      path: '/warehouse/order-detail',
      name: 'warehouseOrder',
      component: warehouseOrder
    },
    {
      path: '/warehouse/order-detail-sub',
      name: 'warehouseOrderSub',
      component: warehouseOrderSub
    },
    {
      path: '/storage-step1',
      name: 'storageStep1',
      component: storageStep1
    },
    {
      path: '/storage-step2',
      name: 'storageStep2',
      component: storageStep2
    },
    {
      path: '/storage-step3',
      name: 'storageStep3',
      component: storageStep3
    },
    {
      path: '/storage-step4',
      name: 'storageStep4',
      component: storageStep4
    },
    {
      path: '/storage-step5',
      name: 'storageStep5',
      component: storageStep5
    },
    {
      path: '/storage/order-detail',
      name: 'storageOrder',
      component: storageOrder
    },
    {
      path: '/storage/order-detail-sub',
      name: 'storageOrderSub',
      component: storageOrderSub
    },
    {
      path: '/storage/order-update',
      name: 'storageOrderUpdate',
      component: storageOrderUpdate
    },
    {
      path: '/general-step1',
      name: 'generalStep1',
      component: generalStep1
    },
    {
      path: '/general-step2',
      name: 'generalStep2',
      component: generalStep2
    },
    {
      path: '/general-step3',
      name: 'generalStep3',
      component: generalStep3
    },
    {
      path: '/general-step4',
      name: 'generalStep4',
      component: generalStep4
    },
    {
      path: '/general-step5',
      name: 'generalStep5',
      component: generalStep5
    },
    {
      path: '/general-step6',
      name: 'generalStep6',
      component: generalStep6
    },
    {
      path: '/clean-parking',
      name: 'cleanParking',
      component: cleanParking
    },
    {
      path: '/suburb',
      name: 'suburbFilter',
      component: suburbFilter
    },
    {
      path: '/clean-switch',
      name: 'cleanSwitch',
      component: cleanSwitch
    },
    {
      path: '/refund-policy',
      name: 'refund',
      component: refund
    },
    {
      path: '/move-terms',
      name: 'moveTerms',
      component: moveTerms
    },
    {
      path: '/terms-and-conditions',
      name: 'terms',
      component: terms
    },
    {
      path: '/order/pay-cash',
      name: 'payCash',
      component: payCash
    },
    {
      path: '/order/pay-bank',
      name: 'payBank',
      component: payBank
    },
    {
      path: '/address-manage',
      name: 'addressList',
      component: addressList
    },
    {
      path: '/clean-comparison',
      name: 'cleanComparison',
      component: cleanComparison
    },
    {
      path: '/info',
      name: 'info',
      component: info
    },
    {
      path: '/contact-us',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/clean-step2',
      name: 'cleanStep2',
      component: cleanStep2
    },
    {
      path: '/clean-step3',
      name: 'cleanStep3',
      component: cleanStep3
    },
    {
      path: '/clean-step4',
      name: 'cleanStep4',
      component: cleanStep4
    },
    {
      path: '/organization-step1',
      name: 'organizationStep1',
      component: organizationStep1
    },
    {
      path: '/organization-step2',
      name: 'organizationStep2',
      component: organizationStep2
    },
    {
      path: '/organization-step3',
      name: 'organizationStep3',
      component: organizationStep3
    },
    {
      path: '/organization-step4',
      name: 'organizationStep4',
      component: organizationStep4
    },
    {
      path: '/organization-step5',
      name: 'organizationStep5',
      component: organizationStep5
    },
    {
      path: '/organization-pricing',
      name: 'organizationPricing',
      component: organizationPricing
    },
    {
      path: '/organization/order-detail',
      name: 'organizationOrder',
      component: organizationOrder
    },
    {
      path: '/organization/abstract',
      name: 'organizationAbstract',
      component: organizationAbstract
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js